import axios from 'axios';

const searchCondition = (queryParams) => {
  let searchText = '';
  searchText += queryParams.filter.name ? `(Name like '%${queryParams.filter.name}%') AND ` : ``;
  searchText += queryParams.filter.type ? `Type=${queryParams.filter.type} AND` : ``;
  return searchText;
};

export async function getCouponCodeList(queryParams) {
  const params = {
    pageIndex: queryParams.pageNumber,
    pageSize: queryParams.pageSize,
    sortText: `${queryParams.sortField} ${queryParams.sortOrder}`,
    // searchText: searchCondition(queryParams),
    searchText: queryParams.filter.code,
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/CouponCode/Get`, params);
  return response.data;
}

export async function getCouponCodeById(couponCodeId) {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/CouponCode/${couponCodeId}`);
  return response.data;
}

// Create =>  POST: add a new request to the server
export async function createUpdateCouponCode(coupon) {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/CouponCode`, coupon);
  return response.data;
}

// DELETE => delete the request from the server
export async function deleteCouponCode(couponCodeId) {
  const response = await axios.delete(
    `${process.env.REACT_APP_API_URL}/CouponCode?Id=${couponCodeId}`
  );
  return response.data;
}

export async function getCouponCodeNameList() {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/CouponCode/Name`);
  return response.data;
}
